// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"4196cb12","213":"bd62cfd4","382":"2b90ba87","667":"4ea8aa3a"}[chunkId] + ".chunk.js";
};